import { render, staticRenderFns } from "./Enter2FAModal.vue?vue&type=template&id=648e63f0"
import script from "./Enter2FAModal.vue?vue&type=script&lang=js"
export * from "./Enter2FAModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports